$ = jQuery;
if (!window.ProductCatalog) {
  window.ProductCatalog = {};
}
